import styled from '@emotion/styled';
import { Trans } from '@lingui/macro';
import { Text } from 'components/text';
import { Button } from 'components/button';
import { useLogout } from '../hooks/federatedAuthHooks';

export const UserNotFound = () => {
  const logout = useLogout();

  return (
    <Container>
      <Text variant="bodyMd" weight="semiBold" align="center">
        <Trans>You have not yet been invited to Delogue PLM.</Trans>
      </Text>
      <Text variant="bodySm" color="secondary" align="center">
        <Trans>
          If you believe this is an error, please contact your organization administrator.
        </Trans>
      </Text>
      <ButtonGroup>
        <Button variant="primary" size="lg" onClick={logout}>
          <Trans>Back to login</Trans>
        </Button>
        <Button
          variant="secondary"
          size="lg"
          component="a"
          href="https://knowledge.delogue.com/how-to-get-support"
        >
          <Trans>Contact support</Trans>
        </Button>
      </ButtonGroup>
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  gap: 24px;
  width: 100%;
`;

const ButtonGroup = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${p => p.theme.s.sm};
`;
